import { render, staticRenderFns } from "./EHR.vue?vue&type=template&id=d496da4e&scoped=true&"
import script from "./EHR.vue?vue&type=script&lang=js&"
export * from "./EHR.vue?vue&type=script&lang=js&"
import style0 from "./EHR.vue?vue&type=style&index=0&id=d496da4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d496da4e",
  null
  
)

export default component.exports